import moment from 'moment';

const THRESHOLDS = {
  HEIGHT: { min: 145, max: 215, message: 'This height is unusual. Please double check.' },
  WEIGHT: { min: 40, max: 110, message: 'This weight is unusual. Please double check.' },
  AGE: { min: 14, max: 50, message: 'This DOB is unusual. Please double check.' },
};

/**
 * Generic range validator - validates if a numeric value is within min/max bounds
 * @param {string|number} value - The value to validate
 * @param {object} config - Validation configuration { min, max, message }
 * @returns {string|null} - Warning message if out of range, null otherwise
 */
const validateRange = (value, { min, max, message }) => {
  const num = parseFloat(value);
  if (value === null || value === undefined || value === '' || isNaN(num)) return null;
  return num < min || num > max ? message : null;
};

const validateHeight = value => validateRange(value, THRESHOLDS.HEIGHT);
const validateWeight = value => validateRange(value, THRESHOLDS.WEIGHT);

const validateDateOfBirth = dob => {
  if (!dob) return null;
  const date = moment(dob);
  if (!date.isValid()) return null;
  const age = moment().diff(date, 'years');
  return age < THRESHOLDS.AGE.min || age > THRESHOLDS.AGE.max ? THRESHOLDS.AGE.message : null;
};

export { validateHeight, validateWeight, validateDateOfBirth, THRESHOLDS };
